module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [(_vm.isModalAuth) ? _c('ModalDefault', {
    attrs: {
      "header": "Дополнительные сведения",
      "center": true,
      "grey": true
    },
    on: {
      "close": _vm.closeEssiaModal
    }
  }, [_c('div', {
    staticClass: "moodal_essia_body"
  }, [_c('ModalEssia', {
    attrs: {
      "errors": _vm.errors
    },
    model: {
      value: (_vm.submitDataEsia),
      callback: function($$v) {
        _vm.submitDataEsia = $$v
      },
      expression: "submitDataEsia"
    }
  })], 1), _c('template', {
    slot: "footer"
  }, [_c('ExtButton', {
    attrs: {
      "fill": false,
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": _vm.acceptModal
    }
  }, [_vm._v("Сохранить")])], 1)], 2) : _vm._e(), _c('router-link', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_vm._v("old home")]), _c('AuthPopups'), _c('Header', {
    staticClass: "layout_header",
    attrs: {
      "layout-header-config": _vm.defaultLayout.config.header,
      "layout-data-set": _vm.defaultLayout.dataSet
    }
  }), _c('main', {
    staticClass: "layout_main"
  }, [_c('router-view', _vm._b({}, 'router-view', _vm.mainPage, false))], 1), _c('Footer', {
    staticClass: "layout_footer",
    attrs: {
      "layout-footer-config": _vm.defaultLayout.config.footer,
      "layout-data-set": _vm.defaultLayout.dataSet
    }
  }), _c('SpecialSections', {
    attrs: {
      "layout-general-config": _vm.defaultLayout.config.general,
      "layout-data-set": _vm.defaultLayout.dataSet
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-144047aa","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/AppDefaultLayout.vue
// module id = 74f2434e1828ed225273
// module chunks = 18